import * as React from 'react';
import { gql } from '@apollo/client';
import type { OperationResult } from '@bondvet/types';
import useBookingMutation from './useBookingMutation';

const trackBookingEventMutation = gql`
    mutation trackBookingEvent(
        $eventName: String!
        $email: String
        $unixTime: Int!
    ) {
        trackBookingEvent(
            eventName: $eventName
            email: $email
            unixTime: $unixTime
            source: "website"
        ) {
            success
            error
        }
    }
`;

type TrackBookingEventMutationResult = {
    trackBookingEvent: OperationResult;
};

type TrackBookingEventMutationVariables = {
    eventName: string;
    email?: string;
    unixTime: number;
};

type TrackBookingEvent = (eventName: string, email?: string) => void;

export default function useTrackBookingEvent(): TrackBookingEvent {
    const [runMutation] = useBookingMutation<
        TrackBookingEventMutationResult,
        TrackBookingEventMutationVariables
    >(trackBookingEventMutation);

    return React.useCallback(
        (eventName: string, email?: string) => {
            runMutation({
                variables: {
                    eventName,
                    email,
                    unixTime: Math.floor(Date.now() / 1000),
                },
            }).then(
                ({ data }) => {
                    if (!data?.trackBookingEvent?.success) {
                        console.warn(
                            'error tracking booking event "%s": server responded with %j',
                            eventName,
                            data,
                        );
                    }
                },
                (error) => {
                    console.warn(
                        'error tracking booking event "%s": %s',
                        email,
                        (error as Error).message,
                    );
                },
            );
        },
        [runMutation],
    );
}
